import React from 'react';
import { Label } from 'reactstrap';
import { WarningHelpText } from 'components/HelpText';

export const Toggle = ({
  checked,
  onChange,
  label,
  warning = '',
  disabled = false,
}) => (
  <div className="d-flex align-items-center gap-2">
    <div
      className={`toggle-switch ${checked ? 'active' : ''}`}
      onClick={disabled ? undefined : onChange}
      style={{
        width: '40px',
        height: '22px',
        borderRadius: '11px',
        backgroundColor: disabled ? '#e9ecef' : checked ? '#0d6efd' : '#ccc',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background-color 0.2s',
        position: 'relative',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRadius: '50%',
          backgroundColor: disabled ? '#adb5bd' : 'white',
          position: 'absolute',
          top: '2px',
          left: checked ? '20px' : '2px',
          transition: 'left 0.2s',
        }}
      />
    </div>
    <Label className={`mb-0 ${disabled ? 'text-muted' : 'text-muted small'}`}>
      {label}
      {warning && <WarningHelpText noBackground>{warning}</WarningHelpText>}
    </Label>
  </div>
);
